var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cs-anon-action-container",
      attrs: { id: "cs-anon-action" },
    },
    [
      _c("div", { staticClass: "cs-anon-action-output" }, [
        _c("div", {
          staticClass: "cs-anon-action-logo cs-bg-primary",
          attrs: { "aria-hidden": "true" },
          domProps: { innerHTML: _vm._s(_vm.logo) },
        }),
        _c("div", { staticClass: "cs-anon-action-body cs-bg-white" }, [
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.requestFailed
                  ? "Thank you for attempting to complete this request."
                  : "Thank you for submitting your request."
              )
            ),
          ]),
          _vm.actionInProgress
            ? _c(
                "div",
                { staticClass: "cs-anon-action-loading" },
                [_c("cs-loading-logo")],
                1
              )
            : _c("div", [
                _c(
                  "span",
                  {
                    class: {
                      "cs-fg-danger": _vm.showActionButton && _vm.actionUrl,
                    },
                  },
                  [_vm._v(_vm._s(_vm.actionResultMessage))]
                ),
                _vm.showActionButton && _vm.actionUrl
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass:
                            "cs-button cs-bg-primary cs-fg-white cs-anon-action-link mt-4",
                          attrs: {
                            href: _vm.actionUrl,
                            "aria-label": "Go to action",
                          },
                        },
                        [_vm._v("Sign in")]
                      ),
                    ])
                  : _vm._e(),
              ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }